export let SliAnalytics = /*#__PURE__*/function (SliAnalytics) {
  SliAnalytics["GetTeamProfile"] = "GetTeamProfile";
  SliAnalytics["GetTeamMembers"] = "GetTeamMembers";
  SliAnalytics["GetTeamLinks"] = "GetTeamLinks";
  SliAnalytics["TeamSearch"] = "TeamSearch";
  SliAnalytics["AccountCentricUserSearch"] = "AccountCentricUserSearch";
  SliAnalytics["LoadProfileAbout"] = "LoadProfileAbout";
  SliAnalytics["GetSettings"] = "GetSettings";
  return SliAnalytics;
}({});